import CommonContent from './Common';

class ImageContents extends CommonContent {
  /* eslint-disable-next-line */
  constructor() {
    super();
  }

  initHTML() {
    let html = '';
    html += this.makeIntro();
    html += this.makeOptionDetailLook();
    html += this.makeSummaryImage();
    html += this.makeTravelCheckList();
    html += this.makeReviewImage();
    html += this.makeMarketImage();
    html += this.makeMiscContent();
    return html;
  }

  initData() {
    const { review, mobileContentSplit, mobileContent } = this.contentInfo;
    // contentType이 IMAGE일 때 노출하는 리뷰 컨텐츠로 플랫폼(PC || Mobile)에 따라 다른 필드를 본다.
    return TMON.oApp.sPlatform === 'PW'
      ? review
      : mobileContentSplit || mobileContent;
  }

  makeIntro() {
    /* 인트로 이미지 - IMAGE 타입 */
    const { introImages = [] } = this.htDealContentInfo.contentImages;
    return introImages.length > 0
      ? `<div class="r2 review_opt">${introImages
          .map(item => this.getLazyImgHtml(item, true))
          .join('')}</div>`
      : '';
  }

  /* 서머리 이미지 */
  makeSummaryImage() {
    const { summary } = this.contentInfo;
    return summary
      ? this.getReplacedInnerDivHtml(summary, 'image_summary')
      : '';
  }

  /* 리뷰 이미지 */
  makeReviewImage() {
    const imageTypeReviewContents = this.initData();
    const hasZero =
      imageTypeReviewContents === '0' ||
      parseInt(imageTypeReviewContents, 10) === 0;
    return imageTypeReviewContents && !hasZero
      ? this.getReplacedInnerDivHtml(imageTypeReviewContents, 'image_review')
      : '';
  }

  /* 홍보 이미지 */
  makeMarketImage() {
    const { viewMarketingImage = true } = this.contentInfo;
    const { marketingImage = '' } = this.htDealContentInfo.contentImages;
    return viewMarketingImage && marketingImage
      ? this.getLazyImgHtml(marketingImage, true)
      : '';
  }
}
export default ImageContents;
